// components/PendingDebtAlert/PendingDebtAlert.tsx
import React from 'react';
import {View, Text, StyleSheet, TouchableOpacity} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {Colors} from '../../../../constants/Colors';

const PendingDebtAlert = () => {
  const {navigate} = useNavigation();

  const handleDebtsPress = () => {
    navigate('Debts');
  };

  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <Text style={styles.title}>Débito em aberto</Text>
        <Text style={styles.description}>
          Você possui um débito vencido há mais de 15 dias. Regularize sua situação para continuar comprando.
        </Text>
        <TouchableOpacity style={styles.button} onPress={handleDebtsPress}>
          <Text style={styles.buttonText}>Ver meus débitos</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: '#FFEBEE',
    borderRadius: 8,
    padding: 16,
    marginHorizontal: 16,
    marginTop: 16,
    borderLeftWidth: 4,
    borderLeftColor: '#B71C1C',
  },
  iconContainer: {
    marginRight: 12,
    paddingTop: 2,
  },
  textContainer: {
    flex: 1,
  },
  title: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    color: '#B71C1C',
    marginBottom: 4,
  },
  description: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Regular',
    color: '#424242',
    lineHeight: 20,
    marginBottom: 12,
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
  },
  buttonText: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Bold',
    color: '#B71C1C',
    marginRight: 4,
  },
});

export default PendingDebtAlert;